import { IconPropType } from ".";

export const TileIcon: React.FC<IconPropType> = ({ width = 16, height = 16, className='' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none" className={className}>
  <g clipPath="url(#clip0_965_3439)">
    <path d="M6.4 0C6.84183 0 7.2 0.358172 7.2 0.8V6.4C7.2 6.84183 6.84183 7.2 6.4 7.2H0.8C0.358172 7.2 0 6.84183 0 6.4V0.8C0 0.358172 0.358172 0 0.8 0H6.4ZM6.4 0.8H0.8V6.4H6.4V0.8ZM15.2 0C15.6418 0 16 0.358172 16 0.8V6.4C16 6.84183 15.6418 7.2 15.2 7.2H9.6C9.15817 7.2 8.8 6.84183 8.8 6.4V0.8C8.8 0.358172 9.15817 0 9.6 0H15.2ZM15.2 0.8H9.6V6.4H15.2V0.8ZM15.2 8.8C15.6418 8.8 16 9.15817 16 9.6V15.2C16 15.6418 15.6418 16 15.2 16H9.6C9.15817 16 8.8 15.6418 8.8 15.2V9.6C8.8 9.15817 9.15817 8.8 9.6 8.8H15.2ZM15.2 9.6H9.6V15.2H15.2V9.6ZM6.4 8.8C6.84183 8.8 7.2 9.15817 7.2 9.6V15.2C7.2 15.6418 6.84183 16 6.4 16H0.8C0.358172 16 0 15.6418 0 15.2V9.6C0 9.15817 0.358172 8.8 0.8 8.8H6.4ZM6.4 9.6H0.8V15.2H6.4V9.6Z" fill="currentColor"/>
  </g>
  <defs>
    <clipPath id="clip0_965_3439">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
);